import { render, staticRenderFns } from "./InstantUpdateColorPicker.vue?vue&type=template&id=5e1bf33a"
import script from "./InstantUpdateColorPicker.vue?vue&type=script&lang=ts"
export * from "./InstantUpdateColorPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports